<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :createRoute="{
                    name: 'rule.create',
                    params: {
                        category_id: categoryId,
                    },
                }"
                :resourceName="$tc('resources.rule.name', 1)"
                :query="categoryFilter"
                ref="table"
            >
                <template #action="{ item }">
                    <edit-btn
                        :to="{
                            name: 'rule.edit',
                            params: { id: item.id, category_id: categoryId },
                        }"
                    />

                    <delete-btn @click="deleteItem(item)" />
                </template>
            </sarala-table>
        </v-row>
        <confirm-delete ref="confirmDelete" />
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Rule from '@/models/Rule'

export default {
    props: ['categoryId'],

    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new Rule()
        },
    },

    methods: {
        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(
                `de ${this.$tc('resources.activation.name', 1).toLowerCase()}`,
            )
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.activation.name', 1),
                }),
            )
        },

        categoryFilter(model) {
            model.where('category_id', this.categoryId)
        },
    },
}
</script>

<style></style>
